// @ts-nocheck
import { Component } from "@theme/component";
import { debounce, onDocumentLoaded, watchAny } from "@theme/utilities";

/**
 * @class ProductTabSlider
 * @extends Component
 */
class ProductTabSlider extends Component {
  #sliderIndex;
  #tabsContent = [];

  constructor() {
    super();

    this.#sliderIndex = watchAny(0, (value, oldValue) => {
      const tabsContent = this.refs?.tabsContent;

      if (
        Array.isArray(tabsContent) &&
        typeof value === "number" &&
        typeof oldValue === "number" &&
        tabsContent[value] &&
        tabsContent[oldValue]
      ) {
        tabsContent[value].classList.remove("hidden");
        tabsContent[oldValue].classList.add("hidden");
        this.#tabsContent[value].refresh();
      }
    });
  }

  connectedCallback() {
    super.connectedCallback();
    void this.init();

    const firstEl = this.querySelector(".tab-item");

    if (firstEl instanceof HTMLElement) {
      this.sliderState = {
        width: firstEl.clientWidth,
        left: firstEl.offsetLeft,
      };
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }

  async init() {
    if (typeof window.Splide === "undefined") {
      await import("@theme/splide");
    }

    const SplideCtor = window.Splide;
    if (!SplideCtor) return;

    this.refs.tabsContent.forEach((el) => {
      this.#tabsContent.push(
        new SplideCtor(el, {
          perPage: 3,
          perMove: 1,
          focus: 0,
          gap: "1rem",
          omitEnd: true,
          pagination: true,
          arrows: true,
          breakpoints: {
            1024: {
              perPage: 2,
              gap: "0.75rem",
              arrows: false,
            },
            750: {
              perPage: 1,
              gap: "0.5rem",
              arrows: false,
            },
          },
        }).mount()
      );
    });
  }

  /**
   * Activate the selected menu item immediately
   * @param {MouseEvent} event
   */
  tabClick(event) {
    const el = event.target;
    if (!(el instanceof HTMLElement)) return;

    const tabsIndex = parseInt(el.dataset.tabsIndex || "0", 10);
    this.#sliderIndex.value = tabsIndex;

    this.sliderState = {
      width: el.clientWidth,
      left: el.offsetLeft,
    };

    // 滚动到中心位置
    this.scrollToCenter(el);
  }

  /**
   * 滚动到中心位置
   * @param {HTMLElement} targetElement
   */
  scrollToCenter(targetElement) {
    const scrollContainer = this.querySelector(".overflow-x-auto");
    if (!scrollContainer) return;

    const containerWidth = scrollContainer.clientWidth;
    const elementLeft = targetElement.offsetLeft;
    const elementWidth = targetElement.clientWidth;

    // 计算目标滚动位置，使元素居中
    const targetScrollLeft = elementLeft - (containerWidth - elementWidth) / 2;

    // 平滑滚动到目标位置
    scrollContainer.scrollTo({
      left: Math.max(0, targetScrollLeft),
      behavior: "smooth",
    });
  }

  /**
   * @param {{width: number, left: number}} value
   */
  set sliderState(value) {
    this.style.setProperty("--tab-slider-width", value.width + "px");
    this.style.setProperty("--tab-slider-left", value.left + "px");
  }
}

if (!customElements.get("product-tab-slider")) {
  customElements.define("product-tab-slider", ProductTabSlider);
}
